import axios from 'axios'
import router from '@/router'

export default {
  getUsers: async ({ commit, rootState, dispatch }) => {
    commit('app/setLoading', { type: 'getUsers', state: true }, { root: true })
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .get(`${process.env.VUE_APP_URL}/adminapi/owners`, config)
        .then(response => {
          commit('setUsers', response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getUsers', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Gets and sets users
   */
  getUsersV2: async ({ commit, rootState, dispatch }, payload) => {
    commit('app/setLoading', { type: 'getUsers', state: true }, { root: true })
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      let url = `${process.env.VUE_APP_URL}/adminapi/owners-v2?pageSize=${payload.pageSize}&page=${payload.page}`
      if (payload.name !== '') {
        url += `&name=${encodeURIComponent(payload.name)}`
      }
      if (payload.whitelistFleetPlaceSearchString !== '') {
        url += `&whitelistFleetPlaceSearchString=${encodeURIComponent(
          payload.whitelistFleetPlaceSearchString
        )}`
      }
      await axios
        .get(url, config)
        .then(response => {
          const nextAvailablePage = parseInt(
            response.headers['x-next-page'],
            10
          )
          commit('setNextAvailablePage', nextAvailablePage)
          commit('setUsers', response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getUsers', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Gets and sets user
   */
  getUser({ commit, rootState, dispatch }, userId) {
    return new Promise((resolve, reject) => {
      commit('app/setLoading', { type: 'getUser', state: true }, { root: true })
      commit('app/setError', null, { root: true })
      try {
        const config = {
          headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
        }
        axios
          .get(`${process.env.VUE_APP_URL}/adminapi/owners/${userId}`, config)
          .then(response => {
            resolve(response.data)
            commit('app/setLoading', { type: '', state: false }, { root: true })
            commit('app/setError', null, { root: true })
          })
          .catch(error => {
            if (error.response.status === 401) {
              dispatch('authentication/logout', null, { root: true })
            }
          })
      } catch (error) {
        reject(error)
        commit(
          'app/setLoading',
          { type: 'getUser', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      }
    })
  },
  /**
   * Posts user if no id and puts user if id > 0
   */
  postUser: async ({ commit, rootState, dispatch }, payload) => {
    commit('app/setLoading', { type: 'postUser', state: true }, { root: true })
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      if (payload.Id > 0) {
        await axios
          .put(`${process.env.VUE_APP_URL}/adminapi/owners`, payload, config)
          .then(() => {
            commit('setUserInUsersArray', payload)
            commit(
              'app/setSnackbar',
              {
                show: true,
                type: 'success',
                message: `User updated successfully`
              },
              { root: true }
            )
            commit('app/setLoading', { type: '', state: false }, { root: true })
            commit('app/setError', null, { root: true })
          })
          .catch(error => {
            if (error.response.status === 401) {
              dispatch('authentication/logout', null, { root: true })
            }
            commit(
              'app/setSnackbar',
              {
                show: true,
                type: 'error',
                message: error.response.data
                  ? error.response.data.Error
                  : `Something went wrong! Please try again later.`
              },
              { root: true }
            )
            commit(
              'app/setLoading',
              { type: 'postUser', state: false },
              { root: true }
            )
            commit('app/setError', error, { root: true })
          })
      } else {
        await axios
          .post(`${process.env.VUE_APP_URL}/adminapi/owners`, payload, config)
          .then(response => {
            commit('addUser', response.data)
            commit(
              'app/setSnackbar',
              {
                show: true,
                type: 'success',
                message: `User added successfully`
              },
              { root: true }
            )
            commit('app/setLoading', { type: '', state: false }, { root: true })
            commit('app/setError', null, { root: true })
          })
          .catch(error => {
            if (error.response.status === 401) {
              dispatch('authentication/logout', null, { root: true })
            }
            commit(
              'app/setSnackbar',
              {
                show: true,
                type: 'error',
                message: error.response.data
                  ? error.response.data.Error
                  : `Something went wrong! Please try again later.`
              },
              { root: true }
            )
            commit(
              'app/setLoading',
              { type: 'postUser', state: false },
              { root: true }
            )
            commit('app/setError', error, { root: true })
          })
      }
    } catch (error) {
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message: error.response.data
            ? error.response.data.Error
            : `Something went wrong! Please try again later.`
        },
        { root: true }
      )
      commit(
        'app/setLoading',
        { type: 'postUser', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Put owner password
   */
  putUserPassword: async ({ commit, rootState, dispatch }, payload) => {
    commit(
      'app/setLoading',
      { type: 'putUserPassword', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })

    const config = {
      headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
    }

    await axios
      .put(
        `${process.env.VUE_APP_URL}/adminapi/owner/password`,
        {
          OwnerId: payload.OwnerId,
          P1: payload.P1,
          P2: payload.P2
        },
        config
      )
      .then(() => {
        commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'success',
            message: `Password updated successfully.`
          },
          { root: true }
        )
        commit('app/setLoading', { type: '', state: false }, { root: true })
        commit('app/setError', null, { root: true })
      })
      .catch(error => {
        if (error.response.status === 401) {
          dispatch('authentication/logout', null, { root: true })
        }
        commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'error',
            message: error.response.data
              ? error.response.data.Error
              : `Something went wrong! Please try again later.`
          },
          { root: true }
        )
        commit(
          'app/setLoading',
          { type: 'putUserPassword', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      })
  },
  /**
   * Removes user/owner
   * @param {Object} - owner object
   */
  deleteUser: async ({ commit, rootState, dispatch }, payload) => {
    commit(
      'app/setLoading',
      { type: 'deleteUser', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .delete(`${process.env.VUE_APP_URL}/adminapi/owners`, {
          headers: config.headers,
          data: payload
        })
        .then(() => {
          commit('removeUserById', payload.Id)
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: `${payload.Email} deleted successfully`
            },
            { root: true }
          )
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
        })
    } catch (error) {
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message: `Something went wrong! Please try again later.`
        },
        { root: true }
      )
      commit(
        'app/setLoading',
        { type: 'deleteUser', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  getUserRegions: async ({ commit, state, rootState, dispatch }) => {
    if (!state.userRegions.length) {
      commit(
        'app/setLoading',
        { type: 'getUserRegions', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      try {
        const config = {
          headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
        }
        await axios
          .get(`${process.env.VUE_APP_URL}/adminapi/owner/regions`, config)
          .then(response => {
            commit('setUserRegions', response.data)
            commit('app/setLoading', { type: '', state: false }, { root: true })
            commit('app/setError', null, { root: true })
          })
          .catch(error => {
            if (error.response.status === 401) {
              dispatch('authentication/logout', null, { root: true })
            }
          })
      } catch (error) {
        commit(
          'app/setLoading',
          { type: 'getUserRegions', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      }
    }
  },
  getUserPlaces: async ({ commit, rootState, dispatch }, payload) => {
    commit(
      'app/setLoading',
      { type: 'getUserPlaces', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      let url = `${process.env.VUE_APP_URL}/adminapi/owner/adminplaces?`
      if (payload && payload.region) {
        url += `&region=${payload.region}`
      }
      if (payload && payload.type) {
        url += `&type=${payload.type}`
      }
      await axios
        .get(url, config)
        .then(response => {
          commit('setUserPlaces', response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getUserPlaces', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  getUserZones: async ({ commit, rootState, dispatch }, payload) => {
    commit(
      'app/setLoading',
      { type: 'getUserZones', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      let url = `${process.env.VUE_APP_URL}/adminapi/owner/zones?admin=true`
      if (payload && payload.region) {
        url += `&region=${payload.region}`
      }
      if (payload && payload.type) {
        url += `&type=${payload.type}`
      }
      await axios
        .get(url, config)
        .then(response => {
          commit('setUserZones', response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getUserZones', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Returns client data
   */
  getClient({ commit, rootState, dispatch }, clientId) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getClient', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      try {
        const config = {
          headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
        }
        axios
          .get(`${process.env.VUE_APP_URL}/adminapi/client/${clientId}`, config)
          .then(response => {
            resolve(response.data)
            commit('app/setLoading', { type: '', state: false }, { root: true })
            commit('app/setError', null, { root: true })
          })
          .catch(error => {
            if (error.response.status === 401) {
              dispatch('authentication/logout', null, { root: true })
            }
          })
      } catch (error) {
        reject(error)
        commit(
          'app/setLoading',
          { type: 'getClient', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      }
    })
  },
  sendNotification({ commit, rootState, dispatch }, payload) {
    commit(
      'app/setLoading',
      { type: 'sendNotification', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })

    const config = {
      headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
    }
    axios
      .post(
        `${process.env.VUE_APP_URL}/adminapi/notifications`,
        payload,
        config
      )
      .then(() => {
        commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'success',
            message: 'Notification sent successfully!'
          },
          { root: true }
        )
        commit(
          'app/setLoading',
          { type: 'sendNotification', state: false },
          { root: true }
        )
        commit('app/setError', null, { root: true })
      })
      .catch(error => {
        if (error.response.status === 401) {
          dispatch('authentication/logout', null, { root: true })
        }
      })
      .catch(error => {
        commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'error',
            message: error.response.data
              ? error.response.data.Error
              : `Something went wrong! Please try again later.`
          },
          { root: true }
        )
        commit(
          'app/setLoading',
          { type: 'sendNotification', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      })
  },
  /**
   * Posts client if no id and puts client if id > 0
   */
  postClient: async ({ commit, rootState, dispatch }, payload) => {
    commit(
      'app/setLoading',
      { type: 'postClient', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .post(`${process.env.VUE_APP_URL}/adminapi/client`, payload, config)
        .then(() => {
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: `User updated successfully`
            },
            { root: true }
          )
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
        })
    } catch (error) {
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message: error.response.data
            ? error.response.data.Error
            : `Something went wrong! Please try again later.`
        },
        { root: true }
      )
      commit(
        'app/setLoading',
        { type: 'postClient', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  payDebts: async ({ commit, rootState, dispatch }, clientId) => {
    commit(
      'app/setLoading',
      { type: 'postClient', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/clients/${clientId}/paydebts`,
          null,
          config
        )
        .then(() => {
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: `Debts paid successfully!`
            },
            { root: true }
          )
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
        })
    } catch (error) {
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message: error.response.data
            ? error.response.data.Error
            : `Something went wrong! Please try again later.`
        },
        { root: true }
      )
      commit(
        'app/setLoading',
        { type: 'postClient', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  setNewPassword: async ({ commit }, payload) => {
    commit(
      'app/setLoading',
      { type: 'setNewPassword', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })

    try {
      axios
        .post(`${process.env.VUE_APP_URL}/admin/password/reset`, {
          uuid: payload.uuid,
          ps1: payload.ps1,
          ps2: payload.ps2
        })
        .then(response => {
          if (!response.data.Error && response.data.Success) {
            commit(
              'app/setSnackbar',
              {
                show: true,
                type: 'success',
                message: payload.this.$vuetify.lang.t(
                  router.currentRoute.name === 'reset'
                    ? '$vuetify.PASSWORD_CHANGED_SUCCESSFULLY'
                    : '$vuetify.ACCOUNT_ACTIVATED_SUCCESSFULLY'
                )
              },
              { root: true }
            )
            router.replace({ path: '/login' })
          } else {
            commit(
              'app/setSnackbar',
              {
                show: true,
                type: 'error',
                message: response.data.Message
              },
              { root: true }
            )
          }
        })
        .catch(err => {
          if (err.response) {
            commit(
              'app/setSnackbar',
              {
                show: true,
                type: 'error',
                message: err.response.data.Error
              },
              { root: true }
            )
          } else {
            commit(
              'app/setSnackbar',
              {
                show: true,
                type: 'error',
                message: payload.this.$vuetify.lang.t('$vuetify.ERROR_GLOBAL')
              },
              { root: true }
            )
          }
        })
    } catch (error) {
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message: error.response.data
            ? error.response.data.Error
            : `Something went wrong! Please try again later.`
        },
        { root: true }
      )
      commit(
        'app/setLoading',
        { type: 'setNewPassword', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  inviteOwner({ commit, rootState, dispatch }, payload) {
    commit(
      'app/setLoading',
      { type: 'inviteOwner', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })

    const config = {
      headers: {
        Authorization: `Bearer ${rootState.authentication.jwt}`,
        Web: 'snabb_dashboard'
      }
    }
    axios
      .post(
        `${process.env.VUE_APP_URL}/adminapi/owners/invite`,
        { OwnerId: payload.Id, InviteToPlatform: 'snabb_dashboard', Language: rootState.app.selectedLanguage.code },
        config
      )
      .then(() => {
        commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'success',
            message: 'Invitation send out successfully!'
          },
          { root: true }
        )
        commit(
          'app/setLoading',
          { type: 'inviteOwner', state: false },
          { root: true }
        )
        commit('app/setError', null, { root: true })
      })
      .catch(error => {
        if (error.response.status === 401) {
          dispatch('authentication/logout', null, { root: true })
        }
        commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'error',
            message: error.response.data
              ? error.response.data.Error
              : `Something went wrong! Please try again later.`
          },
          { root: true }
        )
        commit(
          'app/setLoading',
          { type: 'inviteOwner', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      })
  }
}
